import { Flex, type FlexProps, Button, Typography } from 'antd';
import { type ElementType, type FC } from 'react';

interface EmptyListStateProps
  extends Omit<FlexProps, 'children' | 'flexDirection' | 'justifyContent' | 'alignItems'> {
  title: string;
  description?: string;
  action?: string;
  buttonIcon?: ElementType;
  icon?: ElementType;
  onAction?: () => void;
}

export const EmptyListState: FC<EmptyListStateProps> = ({
  title,
  description,
  action,
  buttonIcon: IconComponent,
  icon: Icon,
  onAction,
  ...flexProps
}) => {
  const { Text } = Typography;

  return (
    <Flex flex="1" {...flexProps} justify="center" align="center" vertical>
      {Icon && (
        <Flex style={{ marginBottom: '24px' }}>
          <Icon />
        </Flex>
      )}

      <Text
        style={{
          marginBottom: '12px',
          fontWeight: 700,
          fontSize: '20px',
          whiteSpace: 'pre-line',
          textAlign: 'center',
          lineHeight: '100%',
        }}
      >
        {title}
      </Text>

      {description && (
        <Text
          style={{
            marginBottom: '15px',
            fontWeight: 600,
            fontSize: '14px',
            whiteSpace: 'pre-line',
            textAlign: 'center',
            lineHeight: '100%',
            color: 'var(--color-text-secondary)',
          }}
        >
          {description}
        </Text>
      )}

      {action && onAction && (
        <Button
          icon={IconComponent && <IconComponent />}
          iconPosition="end"
          onClick={onAction}
          type="primary"
          style={{
            height: '44px',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '8px',
          }}
        >
          {action}
        </Button>
      )}
    </Flex>
  );
};
